import { Page, PageBody, PageContent, PageHeader } from "@corpuscomplete/web/components/layout";
import { Text } from "@corpuscomplete/web-ui/components/text";

export function NotFoundPage() {
  return (
    <Page>
      <PageBody>
        <PageHeader>
          <Text>Not Found</Text>
        </PageHeader>
        <PageContent>
          <Text className="p-4">The page you are looking for does not exist.</Text>
        </PageContent>
      </PageBody>
    </Page>
  );
}
